import { logger } from 'utils/logger'
import { useStore } from '../store'
import { parseBatchUploadFileCall, checkNamesExistCall, addUploadTask } from '../utils/network'
import showAlert from 'utils/showAlert'
import { UPLOAD_TYPES } from 'constants.js'
import { useUploadQueue } from 'hooks/useUploadQueue'
import { validateSettingForm, isSingle, removeApk } from '../utils'
import MtaH5 from 'mta-h5-analysis'
import { useState } from 'react'
import { VALIDATE_RULE } from '../constants'

const useUploadChannelPkg = props => {
    const [store, dispatch] = useStore()
    const { step, uploadType, formData, pkgExistStatus } = store
    // dialogType 可选值: singleReplace(单个替换)、multiUpload（批量上传）、multiReplace（批量替换）
    const { dialogType, appInfo, channelPkgInfo } = props
    const { submitTask } = useUploadQueue()
    const [disableSubmit, setDisableSubmit] = useState(false)

    const handleResultSumbit = async () => {
        props.onCancel && props.onCancel()
        dispatch({ type: 'reset' })
    }

    const handleUploadSumbit = async () => {
        logger.info('step 2 begin')
        // 设置提交按钮不可点，展示loading
        setDisableSubmit(true)
        if (uploadType === UPLOAD_TYPES.LOCAL_UPLOAD) {
            let files = []
            const { exist, notExist } = pkgExistStatus
            const notExistList = Object.keys(notExist)
            const existList = Object.keys(exist)
            // 将文件传到上传管理中心，分片上传文件
            switch (dialogType) {
                case 'singleReplace': {
                    files = Array.from(formData.files).map(file => {
                        file.channelPkgInfo = {
                            ...channelPkgInfo,
                            channelName: formData.channelName,
                        }
                        return file
                    })
                    break
                }
                case 'multiUpload': {
                    files = Array.from(formData.files)
                        .filter(file => {
                            return notExistList.includes(removeApk(file.name))
                        })
                        .map(file => {
                            file.channelPkgInfo = notExist[removeApk(file.name)]
                            return file
                        })

                    break
                }
                case 'multiReplace': {
                    files = Array.from(formData.files)
                        .filter(file => existList.includes(removeApk(file.name)))
                        .map(file => {
                            file.channelPkgInfo = exist[removeApk(file.name)]
                            return file
                        })
                    break
                }
                default:
                    break
            }

            logger.info(`upload by local files: files.length = ${files.length}`)
            if (files.length === 0) {
                showAlert('warn', '选择渠道包为空')
            } else {
                showAlert('success', `成功提交${files.length}个渠道包，请到上传管理中心查看进度`)
            }
            submitTask({
                appInfo,
                files,
            })
            // 文件上传提交上报
            MtaH5.clickStat(`${dialogType}_submitFiles`)
        } else if (uploadType === UPLOAD_TYPES.INPUT_LINK || uploadType === UPLOAD_TYPES.UPLOAD_LINK_CSV) {
            // 直接调用任务处理
            const { appId } = appInfo
            const channelApk = []
            if (uploadType === UPLOAD_TYPES.INPUT_LINK) {
                // 单个替换
                const { channelKey } = channelPkgInfo
                const { url, channelName } = formData
                channelApk.push({
                    channelName,
                    channelKey,
                    url,
                })
            } else {
                const { notExist, exist } = pkgExistStatus
                const { csvFileData } = store
                const notExisNames = Object.keys(notExist)
                const existNames = Object.keys(exist)
                // 批量
                if (dialogType === 'multiUpload') {
                    // 批量上传，上传名称不存在的包
                    Object.keys(csvFileData)
                        .filter(apkname => notExisNames.includes(apkname))
                        .forEach(apkname => {
                            channelApk.push({
                                channelName: apkname, // 完整的 apk 包名
                                url: csvFileData[apkname].value,
                            })
                        })
                } else {
                    // 批量替换，上传名称存在的包
                    Object.keys(csvFileData)
                        .filter(apkname => existNames.includes(apkname))
                        .forEach(apkname => {
                            channelApk.push({
                                channelName: apkname, // 完整的 apk 包名
                                url: csvFileData[apkname].value,
                                channelKey: exist[apkname].channelKey,
                            })
                        })
                }
            }

            // URL上传提交上报
            MtaH5.clickStat(`${dialogType}_submitUrls`)

            logger.info(`upload by link or csv: channelApk.length = ${channelApk.length}`)
            if (channelApk.length === 0) {
                showAlert('warn', '选择渠道包为空')
            } else {
                const { successRecords, failedRecords } = await addUploadTask(
                    appId,
                    channelApk,
                    uploadType === UPLOAD_TYPES.INPUT_LINK
                )
                // showAlert(
                //     'success',
                //     `成功${dialogType === 'multiUpload' ? '上传' : '替换'}${channelApk.length -
                //         failedCount}个渠道包，失败${failedCount}个，可以到上传管理中心查看`
                // )
                dispatch({
                    type: 'PkgUploadStatusReplace',
                    data: {
                        successRecords,
                        failedRecords,
                    },
                })
                // 显示上传结果
                dispatch({ type: 'stepChange', data: 3 })
                logger.info('move to step 3')
                setDisableSubmit(false)
                return
            }
        }
        setDisableSubmit(false)
        props.onCancel && props.onCancel()
        dispatch({ type: 'reset' })
    }

    const stepOneSubmit = async () => {
        // 校验文件名
        const { isValid, formError } = validateSettingForm(dialogType, uploadType, formData)

        // 批量上传时，解析csv文件里的内容并校验渠道号名称
        let csvFileContent = null
        if (uploadType === UPLOAD_TYPES.UPLOAD_LINK_CSV) {
            logger.info('upload by csv')
            const tempContent = await parseBatchUploadFileCall(formData.urlFile)
            const fileNames = Object.keys(tempContent)
            for (let i = 0, len = fileNames.length; i < len; i++) {
                const fileName = fileNames[i]
                // 渠道号名称合格
                if (fileName.endsWith('-32') || fileName.endsWith('-64') || fileName.endsWith('-32-64')) {
                    continue
                } else {
                    const tips = `${VALIDATE_RULE.urlFile.label}文件内的渠道包名称：${fileName} 格式错误，应该以 -32 或 -64 或 -32-64 结尾，指明包体位数`

                    // 渠道号名称不合格，报错
                    dispatch({
                        type: 'formErrorReplace',
                        data: {
                            urlFile: tips,
                        },
                    })

                    logger.error(`parse csv error: ${tips}`)
                    return
                }
            }
            // 所有文件名都合格，可以使用 csv 文件里的内容
            csvFileContent = tempContent
            dispatch({
                type: 'csvFileDataChange',
                data: csvFileContent,
            })

            logger.info(`parse csv success: csvFileContent = ${JSON.stringify(csvFileContent)}`)
        }

        if (isValid) {
            // 单个替换时, 渠道包名称是自动生成的，不采用用户的 apk 文件名，所以不需要进行包体位数的校验
            if (isSingle(dialogType)) {
                logger.info('upload single replace')
                handleUploadSumbit()
            } else {
                const { files } = formData
                let params = {}
                // 上传文件
                if (uploadType === UPLOAD_TYPES.LOCAL_UPLOAD) {
                    logger.info('upload by local files')
                    for (let i = 0; i < files.length; i++) {
                        const channelName = files[i].name.replace('.apk', '')
                        params[channelName] = {
                            channelName,
                            value: files[i],
                            type: 'file',
                        }
                    }
                    // 上传URL的CSV
                } else if (uploadType === UPLOAD_TYPES.UPLOAD_LINK_CSV) {
                    params = csvFileContent
                }

                if (params) {
                    // 检查是否重名
                    checkNamesExistCall(params, appInfo.appId).then(res => {
                        const { exist, notExist } = res
                        dispatch({
                            type: 'PkgExistStatusReplace',
                            data: {
                                exist,
                                notExist,
                            },
                        })
                        // 到第2步
                        dispatch({ type: 'stepChange', data: 2 })
                        logger.info('move to step 2')
                    })
                } else {
                    // 解析结果为空
                    logger.error('csv parse result empty')
                    showAlert('error', '下载链接解析结果为空')
                }
            }
        } else {
            dispatch({ type: 'formErrorReplace', data: formError })
        }
    }

    const handleSubmit = () => {
        logger.info(`handleSubmit: disableSubmit = ${disableSubmit}, step = ${step}`)
        if (disableSubmit) return
        if (step === 1) {
            stepOneSubmit()
        } else if (step === 2) {
            handleUploadSumbit()
        } else if (step === 3) {
            handleResultSumbit()
        }
    }

    const reset = () => {
        dispatch({
            type: 'reset',
        })
    }

    return { handleSubmit, step, reset, disableSubmit }
}

export default useUploadChannelPkg
